export const bookingLink = (sessionId, customerFacingDomain, branchId) => {
    const baseUrl = `https://${customerFacingDomain}/event/${sessionId}`

    if (branchId) {
        return `${baseUrl}?branches.branchID=${branchId}`
    }

    return baseUrl;
}